import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import farDialogStyle from "../../../../assets/jss/user/far/farDialogStyle.jsx";
import LoaderComponent from "../../Loader";

const useStyles = makeStyles(theme => farDialogStyle(theme));

function FarConfirmModal({ open, title, message, confirmText, danger, busy, onClose, onConfirm }){
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={() => (busy ? null : onClose())} classes={{ paper: classes.paper }} aria-labelledby="far-confirm-title" aria-describedby="far-confirm-message">
            <div className={classes.header}>
                <h2 className={classes.title} id="far-confirm-title">{title}</h2>
                <button type="button" className={classes.close} aria-label="Close" onClick={onClose} disabled={busy}><Close /></button>
            </div>
            <div className={classes.body}>
                <p id="far-confirm-message" style={{margin: 0}}>{message}</p>
            </div>
            <div className={classes.footer}>
                <button type="button" className={classes.cancel} onClick={onClose} disabled={busy}>Cancel</button>
                <button type="button" className={danger ? classes.danger : classes.accent} onClick={onConfirm} disabled={busy}>
                    { busy ? <LoaderComponent color="custom" saving={true} /> : confirmText }
                </button>
            </div>
        </Dialog>
    );
}

FarConfirmModal.defaultProps = { confirmText: "Confirm", danger: false, busy: false, message: "" };
FarConfirmModal.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.node,
    confirmText: PropTypes.string,
    danger: PropTypes.bool,
    busy: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default FarConfirmModal;
